import React from "react"
import { useTranslation } from "react-i18next"

import "./_category-block.scss"

import AssetBlock from "./asset-block"

const CategoryBlock = props => {
  const { t } = useTranslation()

  const category = props.category || {}
  const domainUrl = props.domainUrl
  const assets = category.assets || []

  const getLabel = resource => {
    let lang = (process.env.GATSBY_SITE_LANG || "").toLowerCase().split("_")[0]
    return (
      resource.category[lang] ||
      resource.category["en"] ||
      resource.category["all"] ||
      "???"
    )
  }

  const categoryTitle = getLabel(category)

  return (
    <div className="mt-5">
      <h4 className="category-block__title">{t(categoryTitle)}</h4>
      {assets.map((asset, i) => (
        <AssetBlock key={i} asset={asset} domainUrl={domainUrl} />
      ))}
    </div>
  )
}

export default CategoryBlock
